export default __webpack_public_path__ + "static/media/budget-calculator.71e5bf1b.svg";